import { useSafeState } from "ahooks";
import lodash from "lodash";
import { useCallback, useEffect } from "react";
import HBModel from "../../../HBModal";
import PinUploader from "./index";

export default function ModalWrapper(props) {
  const {
    onOk,
    visible,
    targetBoardId,
    onCancel,
    onlyCreation,
    fileList,
    isAiUpload,
  } = props;
  const uploaderParams = ["targetBoardId", "onOk", "onCancel"];
  const [resourceAmount, setResourceAmount] = useSafeState(0);
  const onUploadFileChange = useCallback(
    (resources) => {
      setResourceAmount(resources?.length ?? 0);
    },
    [setResourceAmount]
  );
  const _onOk = useCallback(
    (board, resources, ...args) => {
      onOk && requestAnimationFrame(() => onOk(board, resources, ...args));
    },
    [onOk]
  );

  useEffect(() => {
    if (visible) return;
    setTimeout(() => {
      setResourceAmount(0);
    }, 1000);
  }, [setResourceAmount, visible]);

  return (
    <HBModel
      {...lodash.omit(props, uploaderParams)}
      visible={visible}
      footer={null}
      bodyStyle={{ padding: 0 }}
      width={resourceAmount || fileList?.length > 0 ? 719 : 479}
      destroyOnClose
      onCancel={onCancel}
    >
      {!!visible && (
        <PinUploader
          onOk={_onOk}
          onUploadedFileChange={onUploadFileChange}
          onCancel={onCancel}
          targetBoardId={targetBoardId}
          onlyCreation={onlyCreation}
          fileList={fileList}
          isAiUpload={isAiUpload}
        />
      )}
    </HBModel>
  );
}
